/**
 * Gynécologie-Obstétrique — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: GYN, OBST
 * Catalogue acts (NGAP Maroc): 200
 */
import { defineSpecialty } from "../types";

export const gynecologie = defineSpecialty(
{
  "id": "gynecologie",
  "label": "Gynécologie-Obstétrique",
  "short": "Gynéco-Obst.",
  "scope": "Gynécologie & obstétrique",
  "aliases": [
    "GYN",
    "OBST"
  ],
  "doctorSpecs": [
    "Gynécologie-Obstétrique"
  ],
  "featureFlag": "ux.v2.gynecologie",
  "theme": {
    "primary": "oklch(0.73 0.16 350)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "pregnancy",
      "label": "Grossesse",
      "icon": "Baby",
      "route": "/clinical/pregnancy",
      "order": 2,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 3,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "procedures",
      "label": "Actes",
      "icon": "Sparkles",
      "route": "/clinical/procedures",
      "order": 4,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "pregnancy",
      "label": "Suivi",
      "icon": "Baby",
      "component": "PregnancyTracker",
      "order": 1,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 2,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "component": "ClinicalImageGallery",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Gynécologie",
    "subSpecialties": [
      "Consultation",
      "Accouchement",
      "Césarienne",
      "Suivi de grossesse"
    ],
    "catalogueActs": 200
  },
  "terminology": {
    "icd10": [
      "O00",
      "O09",
      "O20",
      "O80",
      "N92"
    ],
    "loinc": [
      "1988-5",
      "51585-6"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "doppler-fetal",
    "ultrasound-obstetric"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default gynecologie;
